import type { EventBusPayload } from "@/modules/event-bus";

import { useTranslation } from "react-i18next";

import { isJobModuleCompletedNotificationPayload } from "@/entities/broadcast-notification";
import { useUpdateJobModuleStateQueryData } from "@/entities/job-module";
import { useInvalidateNotifications } from "@/entities/notifications";
import { useGetSettingsNotifications } from "@/entities/settings";
import { useAppNotification } from "@/modules/app-notification";
import { useAsyncActions } from "@/modules/async-actions";

import { notifyJobModuleCompleted } from "./job-module-action-completed.helper";

export const useJobModuleActionCompleted = () => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();
  const { updateJobModuleState, invalidateJobModuleList } =
    useUpdateJobModuleStateQueryData();
  const { setUpdatedState } = useAsyncActions();
  const { invalidateNotifications } = useInvalidateNotifications();
  const { isBroadcastNotificationEnabled } = useGetSettingsNotifications();

  const runAction = (payload: EventBusPayload) => {
    if (!isJobModuleCompletedNotificationPayload(payload)) return;
    if (isBroadcastNotificationEnabled(payload.job_module.module_tag)) {
      const title = t("broadcast:jobModuleCompleted", {
        moduleName: payload.job_module.module_name,
      });
      notifyJobModuleCompleted({ notify, title, payload });
    }
    setUpdatedState("jobmodule", payload.job_module.id);
    updateJobModuleState(payload.job_module.id, "Completed");
    invalidateJobModuleList();

    invalidateNotifications("*");
  };

  return { runAction };
};
